import i18n from "i18next";
import translations_en from "./translations_en.json";
import translations_nl from "./translations_nl.json";
import translations_fr from "./translations_fr.json";
import { initReactI18next } from "react-i18next";

export const LANGUAGES = ["en", "nl", "fr"];
export type Languages = "en" | "nl" | "fr";

export const mapStringToLanguage = (
  language?: string
): Languages | undefined => {
  switch (language && language.toUpperCase()) {
    case "NL":
      return "nl";
    case "FR":
      return "fr";
    default:
      return undefined;
  }
};

const translations = {
  en: {
    translation: translations_en,
  },
  nl: {
    translation: translations_nl,
  },
  fr: {
    translation: translations_fr,
  },
};

i18n.languages = LANGUAGES;
i18n.use(initReactI18next).init({
  resources: translations,
  fallbackLng: ["nl", "en"],
  whitelist: LANGUAGES,
  nonExplicitWhitelist: true,
});

export const i18nPatientContext = i18n.cloneInstance();
i18nPatientContext.languages = LANGUAGES;
export const i18nUserContext = i18n.cloneInstance();
i18nUserContext.languages = LANGUAGES;
